export const TUTOR = 'Tutor';
export const STUDENT = 'Student';
export const ADMIN = 'Admin';



// WEBPACK FOOTER //
// ./app/constants/userRoles.js